import script from "./ProductionYardageTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionYardageTab.vue?vue&type=script&setup=true&lang=js"

import "./ProductionYardageTab.vue?vue&type=style&index=0&id=88e655c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88e655c8"]])

export default __exports__